export const getComplianceDocumentIdentifiers = compliance => {
  const uploadedFileId = compliance?.uploadedFileId;
  const vehicleInsuranceId = compliance?.vehicleInsuranceId;

  if (!uploadedFileId || !vehicleInsuranceId) return null;

  return {
    uploadedFileId,
    vehicleInsuranceId,
  };
};
